var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlighter02 = function SvgHighlighter02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.333 18.5v-2h13.334v2zM6.911 13.937l-.064-.064-.68.627h-2.5l1.875-1.942-.051-.051.051.05v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.118 4.658a.167.167 0 0 0-.236 0l-7.057 7.057a.167.167 0 0 0 0 .236l1.724 1.724c.065.065.17.065.236 0l7.057-7.057a.167.167 0 0 0 0-.236zm2.431 1.017a1.167 1.167 0 0 1 0 1.65l-7.057 7.057a1.167 1.167 0 0 1-1.65 0l-1.724-1.724a1.167 1.167 0 0 1 0-1.65l7.057-7.057a1.167 1.167 0 0 1 1.65 0z"
  }))));
};
export default SvgHighlighter02;